import { render, staticRenderFns } from "./standardsectionlist.vue?vue&type=template&id=f24bffc4&scoped=true"
import script from "./standardsectionlist.vue?vue&type=script&lang=js"
export * from "./standardsectionlist.vue?vue&type=script&lang=js"
import style0 from "./standardsectionlist.vue?vue&type=style&index=0&id=f24bffc4&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24bffc4",
  null
  
)

export default component.exports